import { emailConfig } from '../config/email';

// EmailJS integration (if using EmailJS)
// First install: npm install @emailjs/browser
// import emailjs from '@emailjs/browser';

export const sendEmail = async ({ to, subject, message, speakerName }) => {
  try {
    // Replace placeholders in message
    const personalizedMessage = message.replace(/\[Speaker Name\]/g, speakerName || 'Speaker');
    
    // Option 1: Using EmailJS
    // const templateParams = {
    //   to_email: to,
    //   from_email: emailConfig.senderEmail,
    //   from_name: emailConfig.senderName,
    //   subject: subject,
    //   message: personalizedMessage,
    // };
    // 
    // const response = await emailjs.send(
    //   emailConfig.emailjs.serviceId,
    //   emailConfig.emailjs.templateId,
    //   templateParams,
    //   emailConfig.emailjs.userId
    // );
    // return response;

    // Option 2: Using a backend API endpoint
    const response = await fetch(emailConfig.apiEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        to,
        from: emailConfig.senderEmail,
        fromName: emailConfig.senderName,
        subject,
        message: personalizedMessage,
        speakerName,
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to send email: ${response.statusText}`);
    }

    return await response.json();

  } catch (error) {
    console.error('Email sending error:', error);
    throw error;
  }
};

// For development/testing - logs email to console
export const sendEmailDev = async ({ to, subject, message, speakerName }) => {
  console.log('========================================');
  console.log('📧 EMAIL TO SEND (Development Mode)');
  console.log('========================================');
  console.log(`From: ${emailConfig.senderName} <${emailConfig.senderEmail}>`);
  console.log(`To: ${to}`);
  console.log(`Subject: ${subject}`);
  console.log(`Message:\n${message.replace(/\[Speaker Name\]/g, speakerName || 'Speaker')}`);
  console.log('========================================');
  
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: 'Email logged to console (dev mode)' });
    }, 1000);
  });
};